import React from 'react';
import useScrollHint from '../../hooks/useScrollHint';
import './Tabs.css';

/**
 * Tabs — одна вкладочная система вместо четырёх (аудит U3).
 *
 *   variant: 'underline' — переключение разделов страницы (по умолчанию);
 *            'pills'     — фильтр списка («Все / Новые / В работе» со счётчиком).
 *   size:    'sm' | 'md'
 *   tabs:    [{ key, label, count?, icon?, disabled?, title? }]
 *   activeKey, onChange(key)
 *   fullWidth — вкладки делят ширину поровну (ТСД, 2–3 вкладки)
 *
 * Не помещаются — прокручиваются по горизонтали с затуханием края (на телефоне
 * «Отгр…» больше не обрезается). Счётчик — отдельной таблеткой, 0 показывается.
 */
export function Tabs({
  tabs = [],
  activeKey,
  onChange,
  variant = 'underline',
  size = 'md',
  fullWidth = false,
  className = '',
  'aria-label': ariaLabel,
}) {
  const [scrollRef, hintCls] = useScrollHint();
  return (
    <div
      ref={scrollRef}
      className={`ui-tabs ui-tabs--${variant} ui-tabs--${size} ${fullWidth ? 'ui-tabs--full' : ''} ${hintCls} ${className}`}
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map(tab => {
        const active = activeKey === tab.key;
        const Icon = tab.icon;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={tab.disabled}
            title={tab.title}
            className={`ui-tabs__item ${active ? 'ui-tabs__item--active' : ''}`}
            onClick={() => !tab.disabled && onChange && onChange(tab.key)}
          >
            {Icon && <Icon size={size === 'sm' ? 14 : 16} aria-hidden="true" />}
            <span className="ui-tabs__label">{tab.label}</span>
            {tab.count !== undefined && tab.count !== null && (
              <span className="ui-tabs__count">{typeof tab.count === 'number' ? tab.count.toLocaleString('ru-RU') : tab.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
